import classNames from './style.module.scss';

interface LoadingBadgeProps {
	message: string;
}

const LoadingBadge = ({ message }: LoadingBadgeProps) => {
	return (
		<div className={classNames.loadingBadge}>
			<i className="fa fa-spinner fa-spin"></i>
			<span>{message}</span>
		</div>
	);
};

export default LoadingBadge;
